module.exports = __webpack_public_path__ + "static/media/special_8.db788650.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_8.csv
// module id = 744
// module chunks = 0